import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { getCurrentLanguage } from '@/i18next'
import { DigitalSign } from '@/utils/digitalSign'
import { useState } from 'react'

export const HardForm = () => {
	const dispatch = useDispatch()
	const { t } = useTranslation()
	const lang = getCurrentLanguage()
	const digitalSign = new DigitalSign()

	const [isEdit, setIsEdit] = useState(false)

	return (
		<h1>qwe</h1>
	)
}